import{g as T,s as It}from"./chunk-runtime-dom.esm-bundler-D6HuQrXh.js";function $(t){if(typeof t=="string"&&t.startsWith("gid://")){const e=t.split("/");return e[e.length-1]}return t}const kt={"scandinavianbiolabs.com":{token:"83665f41506375971616ff8ad6474a9b",apiUrl:"https://scandinavian-labs-global.myshopify.com/api/2023-07/graphql.json"},"scandinavianbiolabs.co.uk":{token:"38b141caa2bdff18c3197883c861f0fd",apiUrl:"https://scandinavian-labs-uk.myshopify.com/api/2023-07/graphql.json"},"scandinavianbiolabs.us":{token:"21e649a7f70381dd148e2afccbdf87e1",apiUrl:"https://scandinavianbiolabs-us.myshopify.com/api/2023-07/graphql.json"},"scandinavianbiolabs.de":{token:"3d993910045949e86bb7c5d3638939f7",apiUrl:"https://scandinavian-labs-de.myshopify.com/api/2023-07/graphql.json"},"scandinavianbiolabs.dk":{token:"0dc062e2535f4b5b563a84aa4a78d752",apiUrl:"https://scandinavian-labs.myshopify.com/api/2023-07/graphql.json"},"scandinavian-biolabs-test-store.myshopify.com":{token:"1dc72fdb1a1def9d9eb8cd97aad32c7d",apiUrl:"https://scandinavian-biolabs-test-store.myshopify.com/api/2023-07/graphql.json"},"sbl-dev-store.myshopify.com":{token:"88c756496e5cbcb2d96167c534997b8d",apiUrl:"https://sbl-dev-store.myshopify.com/api/2023-07/graphql.json"},"https://i7g2r9xegvhip6wk-70849659035.shopifypreview.com":{token:"83665f41506375971616ff8ad6474a9b",apiUrl:"https://scandinavian-labs-global.myshopify.com/api/2023-07/graphql.json"}},tt=typeof window<"u"&&window.location.hostname?window.location.hostname:"scandinavian-labs-global.myshopify.com",J=T(!1),D=T([]),d=T({}),I=T(!1),Pt=T({code:"",amount:"",targetVariantId:""}),U=T([]),S=T(null),Z=T(!1),rt="sf_cart_id";function X(){return localStorage.getItem(rt)}function $t(t){localStorage.setItem(rt,t)}function _t(){localStorage.removeItem(rt)}async function L(t,e={}){console.log("Current store domain:",tt);const a=kt[tt];if(!a)throw new Error(`No Storefront config for store: ${tt}`);console.log("Using Storefront API URL:",a.apiUrl);try{const o=await(await fetch(a.apiUrl,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":a.token},body:JSON.stringify({query:t,variables:e})})).json();if(o.errors){console.error("GraphQL errors:",JSON.stringify(o.errors,null,2));const c=o.errors.map(n=>n.message).join(", ");throw new Error(`GraphQL Error: ${c}`)}return o.data}catch(i){throw console.error("Network or fetch error in storefrontFetch:",i),i}}async function ot(){I.value=!0;try{let t=X();if(!t){d.value={},I.value=!1;return}const a=await L(`
      query getCart($cartId: ID!) {
        cart(id: $cartId) {
          id
          checkoutUrl
          buyerIdentity {
            countryCode
          }
          attributes {
            key
            value
          }
          discountCodes {
            code
            applicable
          }
          discountAllocations {
            discountedAmount {
              amount
              currencyCode
            }
          }
          lines(first: 50) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                cost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                  compareAtAmountPerQuantity {
                    amount
                    currencyCode
                  }
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                    }
                    selectedOptions {
                      name
                      value
                    }
                    product {
                      id
                      title
                    }
                    image {
                      url
                      altText
                    }
                  }
                }
                sellingPlanAllocation {
                  sellingPlan {
                    id
                    name
                  }
                }
                discountAllocations {
                  discountedAmount {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
            totalTaxAmount {
              amount
              currencyCode
            }
            totalDutyAmount {
              amount
              currencyCode
            }
          }
        }
      }
    `,{cartId:t});if(typeof window<"u"&&window.console,!a.cart)_t(),d.value={};else{const i=F(a.cart);if(typeof window<"u"&&window.console,d.value=i,(!a.cart.buyerIdentity||!a.cart.buyerIdentity.countryCode)&&Ct(t).catch(o=>console.warn("Failed to update buyer identity:",o)),!Z.value){const o=it();o&&await at(t,o)}}}catch{d.value={},_t()}I.value=!1}async function Ut(t,e,a){var m,l,y,_,h,b,C,A,E,N,x,w,q,R;I.value=!0,console.log("addProductToCart called with:",t),console.log("Global bundle logic:",D.value);const i=String(typeof t.id=="string"&&t.id.startsWith("gid://")?t.id.split("/").pop():t.id);console.log("Checking variant ID:",i);let o={};if(D.value&&D.value.length>0){console.log("Found",D.value.length,"bundles to check");for(const f of D.value){if(!f.active)continue;const P=(f.targetProductIds||[]).map(v=>{if(typeof v=="string"&&v.startsWith("gid://")){const g=v.split("/");return g[g.length-1]}return String(v)});if(console.log("Checking bundle targets:",P,"against variant:",i),P.includes(i)){console.log("Variant IS a target! Now checking trigger conditions...");const v=(f.triggerProductIds||[]).map(r=>{if(typeof r=="string"&&r.startsWith("gid://")){const p=r.split("/");return p[p.length-1]}return String(r)}),g=((m=d.value)==null?void 0:m.items)||[];console.log("Cart items:",g.map(r=>r.variant_id)),console.log("Looking for trigger IDs:",v);const s=g.filter(r=>{const p=typeof r.variant_id=="string"&&r.variant_id.startsWith("gid://")?r.variant_id.split("/").pop():String(r.variant_id);return v.includes(p)});console.log("Triggers found in cart:",s.map(r=>r.variant_id));let u=!1;if(f.triggerOperator==="AND"?(u=v.length>0&&v.every(r=>g.some(p=>(typeof p.variant_id=="string"&&p.variant_id.startsWith("gid://")?p.variant_id.split("/").pop():String(p.variant_id))===r)),console.log("AND condition - all triggers needed, met?",u)):f.triggerOperator==="OR"&&(u=s.length>0,console.log("OR condition - at least one trigger needed, met?",u)),u){console.log("Condition MET! Adding bundle properties...");let r=0;if(U.value&&U.value.length>0)for(const z of U.value){const H=(l=z.variants)==null?void 0:l.find(Y=>String(Y.id)===i);if(H){r=Number(H.price);break}}let p=0,O="";f.discountType==="percentage"?(p=Math.round(r*Number(f.discountValue)/100),O=`${f.discountValue}% OFF`):f.discountType==="fixed"&&(p=Number(f.discountValue)*100,O=`${((y=d.value)==null?void 0:y.currency)||"฿"}${(p/100).toFixed(2)} OFF`);const B=Math.max(0,r-p),j=((_=d.value)==null?void 0:_.currency)||"฿",M=`${j}${(r/100).toFixed(2)}`,G=`${j}${(B/100).toFixed(2)}`,V=`${O} (${M} → ${G})`;o={[f.name.replace(/<\/?[^>]+(>|$)/g,"").replace(/&[#\w]+;/g,"").trim()]:V};break}}}}Object.keys(o).length>0&&(t.properties={...t.properties,...o},console.log("Adding product with bundle properties:",t.properties));let c=X(),n;if(c){const f=typeof t.id=="string"&&t.id.startsWith("gid://")?t.id:`gid://shopify/ProductVariant/${t.id}`,P=t.properties||{},v=JSON.stringify(Object.entries(P).sort());let g=null;try{d.value&&d.value.items&&Array.isArray(d.value.items)&&(d.value.items.some(u=>u.selling_plan_allocation===void 0)&&await ot(),g=d.value.items.find(u=>{var V,Q;if(u.variant_id!==f||JSON.stringify(Object.entries(u.properties||{}).sort())!==v)return!1;const p=t.selling_plan?String(t.selling_plan):null,O=(Q=(V=u.selling_plan_allocation)==null?void 0:V.sellingPlan)!=null&&Q.id?u.selling_plan_allocation.sellingPlan.id.split("/").pop():null,B=u.discounts&&u.discounts.length>0;return p===O&&B===!1}))}catch(s){typeof window<"u"&&window.console&&console.warn("Cart search failed, adding as new item:",s),g=null}if(g){const s=`
        mutation updateLine($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
          cartLinesUpdate(cartId: $cartId, lines: $lines) {
            cart {
              id
              checkoutUrl
              buyerIdentity {
                countryCode
              }
              attributes {
                key
                value
              }
              lines(first: 50) {
                edges {
                  node {
                    id
                    quantity
                    attributes {
                      key
                      value
                    }
                    cost {
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                      compareAtAmountPerQuantity {
                        amount
                        currencyCode
                      }
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        title
                        price {
                          amount
                        }
                        selectedOptions {
                          name
                          value
                        }
                        product {
                          id
                          title
                        }
                        image {
                          url
                          altText
                        }
                      }
                    }
                    sellingPlanAllocation {
                      sellingPlan {
                        id
                        name
                      }
                    }
                    discountAllocations {
                      discountedAmount {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
              cost {
                subtotalAmount {
                  amount
                  currencyCode
                }
                totalAmount {
                  amount
                  currencyCode
                }
                totalTaxAmount {
                  amount
                  currencyCode
                }
                totalDutyAmount {
                  amount
                  currencyCode
                }
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `,u={cartId:c,lines:[{id:g.id,quantity:g.quantity+(t.quantity||1)}]};if(n=await L(s,u),!n||!n.cartLinesUpdate)throw typeof window<"u"&&window.console&&console.error("Cart update failed - no cartLinesUpdate in result:",n),new Error("Failed to update cart item quantity - GraphQL error.");if(n.cartLinesUpdate.userErrors&&n.cartLinesUpdate.userErrors.length>0)throw typeof window<"u"&&window.console&&console.error("Cart update user errors:",n.cartLinesUpdate.userErrors),new Error(`Cart update failed: ${n.cartLinesUpdate.userErrors[0].message}`);if(!n.cartLinesUpdate.cart)throw typeof window<"u"&&window.console&&console.error("Cart update failed - no cart in result:",n.cartLinesUpdate),new Error("Failed to update cart item quantity - no cart returned.");d.value=F(n.cartLinesUpdate.cart);const r=(E=n.cartLinesUpdate.cart.lines.edges.find(p=>p.node.id===g.id))==null?void 0:E.node;r&&nt({product_id:$(r.merchandise.product.id),variant_id:$(r.merchandise.id),price:Number.parseFloat(r.merchandise.price.amount)*100,quantity:t.quantity||1,product_type:r.merchandise.product.productType||"",product_title:r.merchandise.product.title,variant_title:r.merchandise.title,image:((N=r.merchandise.image)==null?void 0:N.url)||""})}else{const s=`
        mutation addLines($cartId: ID!, $lines: [CartLineInput!]!) {
          cartLinesAdd(cartId: $cartId, lines: $lines) {
            cart {
              id
              checkoutUrl
              buyerIdentity {
                countryCode
              }
              attributes {
                key
                value
              }
              lines(first: 50) {
                edges {
                  node {
                    id
                    quantity
                    attributes {
                      key
                      value
                    }
                    cost {
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                      compareAtAmountPerQuantity {
                        amount
                        currencyCode
                      }
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        title
                        price {
                          amount
                        }
                        selectedOptions {
                          name
                          value
                        }
                        product {
                          id
                          title
                        }
                        image {
                          url
                          altText
                        }
                      }
                    }
                    sellingPlanAllocation {
                      sellingPlan {
                        id
                        name
                      }
                    }
                    discountAllocations {
                      discountedAmount {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
              cost {
                subtotalAmount {
                  amount
                  currencyCode
                }
                totalAmount {
                  amount
                  currencyCode
                }
                totalTaxAmount {
                  amount
                  currencyCode
                }
                totalDutyAmount {
                  amount
                  currencyCode
                }
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `,u={cartId:c,lines:[et(t)]};if(n=await L(s,u),((w=(x=n==null?void 0:n.cartLinesAdd)==null?void 0:x.userErrors)==null?void 0:w.length)>0){const r=n.cartLinesAdd.userErrors.map(p=>p.message).join(", ");throw console.error("Cart lines add errors:",n.cartLinesAdd.userErrors),console.error("Failed line input:",et(t)),new Error(`Failed to add product to cart: ${r}`)}if(!n||!n.cartLinesAdd||!n.cartLinesAdd.cart)throw console.error("Full mutation result:",JSON.stringify(n,null,2)),new Error("Product cannot be added to cart. Please check if the product is available.");d.value=F(n.cartLinesAdd.cart)}if(!Z.value){const s=it();s&&await at(c,s)}if(n.cartLinesAdd&&n.cartLinesAdd.cart){const s=(q=n.cartLinesAdd.cart.lines.edges[n.cartLinesAdd.cart.lines.edges.length-1])==null?void 0:q.node;s&&nt({product_id:$(s.merchandise.product.id),variant_id:$(s.merchandise.id),price:Number.parseFloat(s.merchandise.price.amount)*100,quantity:t.quantity||1,product_type:s.merchandise.product.productType||"",product_title:s.merchandise.product.title,variant_title:s.merchandise.title,image:((R=s.merchandise.image)==null?void 0:R.url)||""})}}else{const f=At(),P=it(),v=`
      mutation createCart($lines: [CartLineInput!]!, $buyerIdentity: CartBuyerIdentityInput) {
        cartCreate(input: { lines: $lines, buyerIdentity: $buyerIdentity }) {
          cart {
            id
            checkoutUrl
            buyerIdentity {
              countryCode
            }
            attributes {
              key
              value
            }
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  cost {
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      price {
                        amount
                      }
                      selectedOptions {
                        name
                        value
                      }
                      product {
                        id
                        title
                      }
                      image {
                        url
                        altText
                      }
                    }
                  }
                  sellingPlanAllocation {
                    sellingPlan {
                      id
                      name
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `,g={lines:[et(t)],buyerIdentity:f};if(n=await L(v,g),((b=(h=n==null?void 0:n.cartCreate)==null?void 0:h.userErrors)==null?void 0:b.length)>0){const r=n.cartCreate.userErrors.map(p=>p.message).join(", ");throw console.error("Cart creation errors:",n.cartCreate.userErrors),new Error(`Failed to create cart: ${r}`)}if(!n||!n.cartCreate||!n.cartCreate.cart)throw typeof window<"u"&&window.console&&console.error("Full mutation result:",JSON.stringify(n,null,2)),new Error("Cart creation failed: cart is null");const s=n.cartCreate.cart;$t(s.id),d.value=F(s),P&&!Z.value&&await at(s.id,P),Ct(s.id).catch(r=>console.warn("Failed to update buyer identity:",r));const u=(C=s.lines.edges[0])==null?void 0:C.node;u&&nt({product_id:$(u.merchandise.product.id),variant_id:$(u.merchandise.id),price:Number.parseFloat(u.merchandise.price.amount)*100,quantity:u.quantity,product_type:u.merchandise.product.productType||"",product_title:u.merchandise.product.title,variant_title:u.merchandise.title,image:((A=u.merchandise.image)==null?void 0:A.url)||""})}e||await ot(),I.value=!1}function At(){var e,a,i,o;const t={};return typeof window<"u"&&((e=window.Shopify)!=null&&e.country?t.countryCode=window.Shopify.country:(o=(i=(a=window.ShopifyAnalytics)==null?void 0:a.meta)==null?void 0:i.page)!=null&&o.country&&(t.countryCode=window.ShopifyAnalytics.meta.page.country)),Object.keys(t).length>0?t:null}function it(){var a,i,o,c,n,m;if(typeof document>"u")return null;const t={},e=document.cookie.split(";").reduce((l,y)=>{const[_,h]=y.trim().split("=");return l[_]=h,l},{});if(e._shopify_s&&(t.sessionId=e._shopify_s),e._shopify_y&&(t.browserId=e._shopify_y),typeof window<"u"&&window.ShopifyAnalytics){const l=window.ShopifyAnalytics;(i=(a=l.meta)==null?void 0:a.page)!=null&&i.pageUrl&&(t.landingPage=l.meta.page.pageUrl),(c=(o=l.meta)==null?void 0:o.page)!=null&&c.referrer&&(t.referrer=l.meta.page.referrer),(m=(n=l.meta)==null?void 0:n.page)!=null&&m.channel&&(t.channel=l.meta.page.channel)}if(typeof window<"u"){const l=new URLSearchParams(window.location.search),y={};["utm_source","utm_medium","utm_campaign","utm_term","utm_content"].forEach(h=>{l.get(h)&&(y[h]=l.get(h))}),Object.keys(y).length>0&&(t.utmParams=y)}return Object.keys(t).length>0?t:null}async function at(t,e){var a,i;try{const o=[];if(e.sessionId&&o.push({key:"_session_id",value:e.sessionId}),e.browserId&&o.push({key:"_browser_id",value:e.browserId}),e.landingPage&&o.push({key:"_landing_page",value:e.landingPage}),e.referrer&&o.push({key:"_referrer",value:e.referrer}),e.channel&&o.push({key:"_channel",value:e.channel}),e.utmParams&&Object.entries(e.utmParams).forEach(([l,y])=>{o.push({key:l,value:y})}),o.push({key:"_attribution_timestamp",value:new Date().toISOString()}),o.length===0)return;const m=await L(`
      mutation updateAttributes($cartId: ID!, $attributes: [AttributeInput!]!) {
        cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
          cart {
            id
            attributes {
              key
              value
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `,{cartId:t,attributes:o});((i=(a=m==null?void 0:m.cartAttributesUpdate)==null?void 0:a.userErrors)==null?void 0:i.length)>0?console.warn("Immediate session attribution errors:",m.cartAttributesUpdate.userErrors):Z.value=!0}catch(o){console.warn("Failed to set immediate session attribution:",o)}}async function Ct(t){var e,a;try{const i=At();if(!i)return;const n=await L(`
      mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart {
            id
            buyerIdentity {
              countryCode
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `,{cartId:t,buyerIdentity:i});((a=(e=n==null?void 0:n.cartBuyerIdentityUpdate)==null?void 0:e.userErrors)==null?void 0:a.length)>0&&console.warn("Buyer identity update errors:",n.cartBuyerIdentityUpdate.userErrors)}catch(i){console.warn("Failed to update buyer identity:",i)}}function et(t){let e=t.id;typeof e=="number"&&(e=String(e));const a={quantity:t.quantity||1,merchandiseId:e.startsWith("gid://")?e:`gid://shopify/ProductVariant/${e}`,attributes:t.properties?Object.entries(t.properties).filter(([i,o])=>o!=null&&o!=="").map(([i,o])=>({key:i,value:String(o)})):[]};return a.attributes.length>0&&(console.log("Line input attributes being sent to Shopify:",a.attributes),console.log("Full line input:",JSON.stringify(a,null,2))),t.selling_plan&&(a.sellingPlanId=String(t.selling_plan).startsWith("gid://")?t.selling_plan:`gid://shopify/SellingPlan/${t.selling_plan}`),a}async function Lt(t,e){I.value=!0;const a=X();if(!a)return;const i=`
    mutation updateAttributes($cartId: ID!, $attributes: [AttributeInput!]!) {
      cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
        cart {
          id
          checkoutUrl
          attributes {
            key
            value
          }
          lines(first: 50) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                cost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                  compareAtAmountPerQuantity {
                    amount
                    currencyCode
                  }
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                    }
                    selectedOptions {
                      name
                      value
                    }
                    product {
                      id
                      title
                    }
                    image {
                      url
                      altText
                    }
                  }
                }
                discountAllocations {
                  discountedAmount {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
            totalTaxAmount {
              amount
              currencyCode
            }
            totalDutyAmount {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `,o={cartId:a,attributes:[{key:t,value:String(e)}]},c=await L(i,o);d.value=F(c.cartAttributesUpdate.cart),I.value=!1}async function qt(t){I.value=!0;const e=X();if(!e)return;const a=`
    mutation updateDiscount($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          checkoutUrl
          attributes {
            key
            value
          }
          lines(first: 50) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                cost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                  compareAtAmountPerQuantity {
                    amount
                    currencyCode
                  }
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                    }
                    selectedOptions {
                      name
                      value
                    }
                    product {
                      id
                      title
                    }
                    image {
                      url
                      altText
                    }
                  }
                }
                discountAllocations {
                  discountedAmount {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
            totalTaxAmount {
              amount
              currencyCode
            }
            totalDutyAmount {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `,i=[t.code].filter(Boolean),c=await L(a,{cartId:e,discountCodes:i});d.value=F(c.cartDiscountCodesUpdate.cart),I.value=!1}const Ot=It(()=>{const t=d.value.attributes||{};return{code:t["BOGO Discount Code"]||"",amount:t["BOGO Discount Amount"]||"",targetVariantId:t["BOGO Discount Target Variant Id"]||""}});async function Tt(t,e,a){e=Number(e),I.value=!0;const i=X();if(i){if(e===0){const n=await L(`
      mutation removeLine($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
          cart {
            id
            checkoutUrl
            attributes {
              key
              value
            }
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  cost {
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      price {
                        amount
                      }
                      selectedOptions {
                        name
                        value
                      }
                      product {
                        id
                        title
                      }
                      image {
                        url
                        altText
                      }
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }
    `,{cartId:i,lineIds:[t]});d.value=F(n.cartLinesRemove.cart)}else{const n=await L(`
      mutation updateLine($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            id
            checkoutUrl
            attributes {
              key
              value
            }
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  cost {
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      price {
                        amount
                      }
                      selectedOptions {
                        name
                        value
                      }
                      product {
                        id
                        title
                      }
                      image {
                        url
                        altText
                      }
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }
    `,{cartId:i,lines:[{id:t,quantity:e}]});d.value=F(n.cartLinesUpdate.cart)}I.value=!1}}function Et(){J.value=!0}function Nt(){J.value=!1}function xt(){J.value=!J.value}function Ft(){window.location.href="/cart"}function Vt(){d.value.checkoutUrl&&(window.location.href=d.value.checkoutUrl)}function Dt(t){var i,o,c,n,m,l,y,_,h;const e=t.merchandise,a=(t.discountAllocations||[]).reduce((b,C)=>{var A;return b+Number(((A=C.discountedAmount)==null?void 0:A.amount)||0)},0)*100;return{id:t.id,quantity:t.quantity,variant_id:e.id,product_id:e.product.id,product_title:e.product.title,variant_title:e.title||"",image:((i=e.image)==null?void 0:i.url)||"",variant_options:e.selectedOptions?e.selectedOptions.map(b=>b.value):[],price:(o=e.price)!=null&&o.amount?Number.parseInt(e.price.amount*100):0,discounted_price:(n=(c=t.cost)==null?void 0:c.totalAmount)!=null&&n.amount?Number.parseInt(t.cost.totalAmount.amount*100):0,subtotal_price:(l=(m=t.cost)==null?void 0:m.subtotalAmount)!=null&&l.amount?Number.parseInt(t.cost.subtotalAmount.amount*100):0,compare_at_price:(_=(y=t.cost)==null?void 0:y.compareAtAmountPerQuantity)!=null&&_.amount?Number.parseInt(t.cost.compareAtAmountPerQuantity.amount*100):0,discounts:((h=t.discountAllocations)==null?void 0:h.map(b=>{var C,A;return{amount:((C=b.discountedAmount)==null?void 0:C.amount)||0,currency_code:((A=b.discountedAmount)==null?void 0:A.currencyCode)||""}}))||[],line_discount:a,properties:{},featured_image:e.image?{url:e.image.url,alt:e.image.altText}:{},product_has_only_default_variant:!1,selling_plan_allocation:t.sellingPlanAllocation||null}}function Bt(t){const e=Dt(t),a=typeof e.product_id=="string"&&e.product_id.includes("/")?e.product_id.split("/").pop():e.product_id,i=U.value.find(o=>String(o.id)===String(a));return e.product_has_only_default_variant=(i==null?void 0:i.has_only_default_variant)||!1,e.product_type=(i==null?void 0:i.product_type)||"",e}function F(t){var m,l,y,_,h,b,C,A,E,N,x;const e=Number(((l=(m=t.cost)==null?void 0:m.totalAmount)==null?void 0:l.amount)||0)*100,a=Number(((_=(y=t.cost)==null?void 0:y.subtotalAmount)==null?void 0:_.amount)||0)*100,i=a-e,o=((h=t.discountCodes)==null?void 0:h.map(w=>({title:w.code,applicable:w.applicable})))||[],c={},n=["Discount Name","discount_name","discount_title","Discount Title"];return t.attributes&&t.attributes.forEach(w=>{c[w.key]=w.value,n.some(q=>w.key.toLowerCase().includes(q.toLowerCase()))&&o.push({title:w.value,applicable:!0,source:"attribute"})}),{...t,items:((b=t.lines)==null?void 0:b.edges.map(w=>Bt(w.node)))||[],item_count:((C=t.lines)==null?void 0:C.edges.reduce((w,q)=>w+q.node.quantity,0))||0,total_price:e,items_subtotal_price:a,total_discount:i,total_tax:Number(((E=(A=t.cost)==null?void 0:A.totalTaxAmount)==null?void 0:E.amount)||0)*100,total_duty:Number(((x=(N=t.cost)==null?void 0:N.totalDutyAmount)==null?void 0:x.amount)||0)*100,cart_discount_allocations:t.discountAllocations||[],discount_applications:t.discountAllocations||[],discount_codes:t.discountCodes||[],discount_names:o,attributes:c}}function nt(t){var e,a,i,o,c,n,m,l,y,_,h,b,C,A,E,N,x,w,q,R,f,P,v,g,s,u,r,p,O,B,j,M,G,V,Q,z,H,Y,ct,ut,st,dt,lt,pt,mt,yt,ft,gt,ht,wt;try{let K="",vt="Scandinavian Biolabs",bt="";if(console.log("productsRegistry: ",U.value,t.product_id),U.value&&U.value.length>0){const k=U.value.find(W=>String($(W.id))===String($(t.product_id)));if(k){const W=(e=k.variants)==null?void 0:e.find(St=>String($(St.id))===String($(t.variant_id)));W&&(K=W.sku||""),vt=k.vendor||"Scandinavian Biolabs",bt=k.product_type||""}}if(typeof window<"u"){if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish&&(window.Shopify.analytics.publish("product_added_to_cart",{clientId:((o=(i=(a=window.ShopifyAnalytics)==null?void 0:a.meta)==null?void 0:i.page)==null?void 0:o.customerId)||null,timestamp:new Date().toISOString(),context:{document:{location:{href:window.location.href,hash:window.location.hash,host:window.location.host,hostname:window.location.hostname,origin:window.location.origin,pathname:window.location.pathname,port:window.location.port,protocol:window.location.protocol,search:window.location.search},referrer:document.referrer,characterSet:document.characterSet,title:document.title},navigator:{language:navigator.language,cookieEnabled:navigator.cookieEnabled,userAgent:navigator.userAgent},window:{innerHeight:window.innerHeight,innerWidth:window.innerWidth,outerHeight:window.outerHeight,outerWidth:window.outerWidth,pageXOffset:window.pageXOffset,pageYOffset:window.pageYOffset,location:{href:window.location.href,hash:window.location.hash,host:window.location.host,hostname:window.location.hostname,origin:window.location.origin,pathname:window.location.pathname,port:window.location.port,protocol:window.location.protocol,search:window.location.search},origin:window.location.origin,screenX:window.screenX||0,screenY:window.screenY||0,scrollX:window.scrollX||0,scrollY:window.scrollY||0}},data:{cartLine:{cost:{totalAmount:{amount:(t.price/100).toString(),currencyCode:((c=d.value)==null?void 0:c.currency)||((m=(n=window.Shopify)==null?void 0:n.currency)==null?void 0:m.active)||"USD"}},merchandise:{id:`gid://shopify/ProductVariant/${t.variant_id}`,image:t.image?{src:t.image}:null,price:{amount:(t.price/100).toString(),currencyCode:((l=d.value)==null?void 0:l.currency)||((_=(y=window.Shopify)==null?void 0:y.currency)==null?void 0:_.active)||"USD"},product:{id:`gid://shopify/Product/${t.product_id}`,title:t.product_title,type:t.product_type,vendor:"Scandinavian Biolabs"},sku:"",title:t.variant_title,untranslatedTitle:t.variant_title},quantity:t.quantity}}}),window.Shopify.analytics.publish("added_to_cart",{productGid:`gid://shopify/Product/${t.product_id}`,variantGid:`gid://shopify/ProductVariant/${t.variant_id}`,productId:t.product_id,variantId:t.variant_id,name:t.product_title,variant:t.variant_title,category:t.product_type,brand:"Scandinavian Biolabs",price:t.price/100,quantity:t.quantity,currency:((h=d.value)==null?void 0:h.currency)||((C=(b=window.Shopify)==null?void 0:b.currency)==null?void 0:C.active)||"USD",value:t.price/100,url:window.location.href})),window.ShopifyAnalytics&&window.ShopifyAnalytics.lib&&window.ShopifyAnalytics.lib.track("Added Product",{productId:t.product_id,variantId:t.variant_id,price:t.price/100,quantity:t.quantity,productType:t.product_type,productTitle:t.product_title,variantTitle:t.variant_title}),window._learnq&&window._learnq.push(["track","Added to Cart",{$value:t.price/100,ProductID:t.product_id,ProductName:t.product_title,Quantity:t.quantity,Categories:[t.product_type],ImageURL:t.image,URL:window.location.href,Brand:"Scandinavian Biolabs"}]),window.dataLayer){window.dataLayer.push({event:"add_to_cart",currency:((A=d.value)==null?void 0:A.currency)||((N=(E=window.Shopify)==null?void 0:E.currency)==null?void 0:N.active)||"USD",value:t.price/100,items:[{item_id:t.variant_id,item_name:t.product_title,item_category:t.product_type,item_variant:t.variant_title,price:t.price/100,quantity:t.quantity}]});let k=((w=(x=S.value)==null?void 0:x.address)==null?void 0:w.country_code)||((R=(q=S.value)==null?void 0:q.address)==null?void 0:R.countryCode)||((P=(f=d.value)==null?void 0:f.buyerIdentity)==null?void 0:P.countryCode)||((v=window.Shopify)==null?void 0:v.country)||((u=(s=(g=window.ShopifyAnalytics)==null?void 0:g.meta)==null?void 0:s.page)==null?void 0:u.country)||((p=(r=S.value)==null?void 0:r.address)==null?void 0:p.country)||"";k&&k.length<=3&&(k=k.toUpperCase());const W={event:"add_to_cart_custom",ecomm_pagetype:"product",ecommerce:{currency:((O=d.value)==null?void 0:O.currency)||((j=(B=window.Shopify)==null?void 0:B.currency)==null?void 0:j.active)||"USD",value:String(t.price/100),items:[{imageURL:t.image||"",item_brand:vt,item_category:bt,item_id:String(t.product_id),item_name:t.product_title,item_sku:K,item_variant:String(t.variant_id),price:t.price/100,quantity:String(t.quantity),variant_name:t.variant_title||""}]},user_data:{city:((G=(M=S.value)==null?void 0:M.address)==null?void 0:G.city)||"",country:k,customer_id:((V=S.value)==null?void 0:V.id)||((H=(z=(Q=window.ShopifyAnalytics)==null?void 0:Q.meta)==null?void 0:z.page)==null?void 0:H.customerId)||"",email:((Y=S.value)==null?void 0:Y.email)||((st=(ut=(ct=window.ShopifyAnalytics)==null?void 0:ct.meta)==null?void 0:ut.page)==null?void 0:st.customerEmail)||"",first_name:((dt=S.value)==null?void 0:dt.first_name)||"",last_name:((lt=S.value)==null?void 0:lt.last_name)||"",phone:((pt=S.value)==null?void 0:pt.phone)||"",region:((yt=(mt=S.value)==null?void 0:mt.address)==null?void 0:yt.province)||"",street:((gt=(ft=S.value)==null?void 0:ft.address)==null?void 0:gt.address1)||"",zip:((wt=(ht=S.value)==null?void 0:ht.address)==null?void 0:wt.zip)||""}};window.dataLayer.push(W)}if(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta){const k=new CustomEvent("submit",{bubbles:!0,cancelable:!0,detail:{productId:t.product_id,variantId:t.variant_id,quantity:t.quantity}});window.ShopifyAnalytics.meta.page&&(window.ShopifyAnalytics.meta.page.resourceId=t.product_id,window.ShopifyAnalytics.meta.page.resourceType="product")}}}catch(K){console.warn("Failed to trigger add-to-cart tracking:",K)}}function Qt(t={}){var o;const e=T(t.products||[]);(o=t.products)!=null&&o.length&&(U.value=t.products),t.customer&&(S.value=t.customer),t.bundleLogic&&(D.value=t.bundleLogic);function a(c){e.value=c,U.value=c}function i(c){D.value=c}return{isSlidecartVisible:J,cart:d,bogoDiscount:Ot,loading:I,discountCodeApplied:Pt,addProductToCart:Ut,setCartAttribute:Lt,setCartAttributeDiscount:qt,changeQuantity:Tt,refreshCartItems:ot,setSlidecartVisible:Et,setSlidecartHidden:Nt,toggleSlidecartVisible:xt,redirectToCartPage:Ft,redirectToCheckoutPage:Vt,updateProducts:a,updateBundleLogic:i}}export{$ as e,Qt as u};
